import { useEffect, useState } from "react";
import AdminPageLayout from "../components/AdminPageLayout";
import { fetchMediaVideoUses, createMediaVideoUse, deleteMediaVideoUse } from "./adminMediaVideoService";
import { useToast } from "../../common/toast/ToastContext";

const AdminMediaVideoUsesPage = () => {
  const { showToast } = useToast();
  const [uses, setUses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newName, setNewName] = useState("");
  const [saving, setSaving] = useState(false);
  const [rowErrors, setRowErrors] = useState({});

  const load = async () => {
    setLoading(true);
    const res = await fetchMediaVideoUses();
    if (res.status === 200) setUses(res.data || []);
    else showToast("Failed to load video uses", "error");
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const handleAdd = async () => {
    const name = newName.trim().toUpperCase();
    if (!name) return;
    setSaving(true);
    const res = await createMediaVideoUse(name);
    if (res.status === 200 || res.status === 201) {
      showToast("Video use created", "success");
      setNewName("");
      await load();
    } else if (res.status === 409) {
      showToast("Video use already exists", "error");
    } else {
      showToast(res.message || "Create failed", "error");
    }
    setSaving(false);
  };

  const handleDelete = async (use) => {
    setRowErrors((prev) => ({ ...prev, [use]: "" }));
    const res = await deleteMediaVideoUse(use);
    if (res.status === 200 || res.status === 204) {
      showToast("Video use deleted", "success");
      await load();
    } else if (res.status === 400) {
      setRowErrors((prev) => ({ ...prev, [use]: "Cannot delete — video use is in use" }));
    } else if (res.status === 404) {
      showToast("Video use not found", "error");
    } else {
      showToast(res.message || "Delete failed", "error");
    }
  };

  return (
    <AdminPageLayout
      title="Media Video Uses"
      subtitle="Manage the video use categories available for media videos."
    >
      <div style={{ display: "flex", gap: 8, marginBottom: "1.5rem", maxWidth: 400 }}>
        <input
          value={newName}
          onChange={(e) => setNewName(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleAdd()}
          placeholder="New video use name"
          style={{ flex: 1, padding: "0.45rem 0.75rem", border: "1px solid #d1d5db", borderRadius: 6, fontSize: "0.9rem" }}
        />
        <button className="adm-btn adm-btn-primary" onClick={handleAdd} disabled={saving || !newName.trim()}>
          {saving ? "Adding…" : "Add"}
        </button>
      </div>

      {loading ? (
        <p className="adm-loading">Loading…</p>
      ) : uses.length === 0 ? (
        <p className="adm-empty">No video uses yet.</p>
      ) : (
        <div className="ac-table-wrap">
          <table className="ac-table">
            <thead>
              <tr>
                <th>Video Use Name</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {uses.map((use) => (
                <tr key={use}>
                  <td>
                    <strong>{use}</strong>
                    {rowErrors[use] && (
                      <span style={{ marginLeft: 10, color: "#b91c1c", fontSize: "0.82rem" }}>
                        {rowErrors[use]}
                      </span>
                    )}
                  </td>
                  <td>
                    <button className="adm-btn adm-btn-danger adm-btn-sm" onClick={() => handleDelete(use)}>
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </AdminPageLayout>
  );
};

export default AdminMediaVideoUsesPage;
